var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recom"},[_c('h3',{staticClass:"h3-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"recom-description",class:{'active': _vm.isOpen},domProps:{"innerHTML":_vm._s(_vm.single)}}),_c('button',{staticClass:"recom-more",on:{"click":_vm.open}},[_vm._v(_vm._s(!_vm.isOpen ? 'Читать дальше...' : 'Скрыть'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }